import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  /** Shown in the fallback, e.g. "Timeline". */
  area: string;
  children: ReactNode;
}

/** Contains a crash to one area of the UI instead of blanking the whole app. */
export class ErrorBoundary extends Component<Props, { error: Error | null }> {
  override state = { error: null as Error | null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    console.error(`${this.props.area} crashed`, error, info.componentStack);
  }

  override render() {
    const { error } = this.state;
    if (!error) return this.props.children;
    return (
      <div className="panel crash" role="alert">
        <div className="dialog-body">
          <strong>{this.props.area} ran into a problem.</strong>
          <p className="muted">{error.message}</p>
          <button
            className="btn small"
            data-tooltip="Try rendering this area again"
            onClick={() => this.setState({ error: null })}
          >
            Try again
          </button>
        </div>
      </div>
    );
  }
}
